export default __webpack_public_path__ + "static/Fig 5 - Indicative Infra A3-70a5e6b4d71b2e1171c3933e413ec562.pdf";